var MarginTool = function(text, locale) {
	var self = this;

	this.text = text;
	this.locale = locale;
	this.data = {
		abinbev: new MarginToolData(),
		competition: new MarginToolData()
	};

	Chart.defaults.font.family = 'Satoshi';
	Chart.defaults.color = "#000";
	Chart.defaults.font.size = 16;

	this.chart = new Chart(document.getElementById('chart'), {
		type: 'bar',
		data: {
			labels: ['', ''],
			datasets: [
				{
					label: this.text.Marge, //'Marge',
					data: [0, 0],
					backgroundColor: '#CAA44F'
				},
				{
					label: this.text.Jaarlijkse_investering, //'Jaarlijkse investering €',
					data: [0, 0],
					backgroundColor: '#DEB741'
				},
				{
					label: this.text.Bonus_Management, //'Bonus Management €/hL',
					data: [0, 0],
					backgroundColor: '#C7C7C7'
				},
			]
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				x: {
					stacked: true,
				},
				y: {
					stacked: true,
					ticks: {
						callback: function(value) {
							return "€ " + value.toLocaleString(self.locale)
						}
					},
					afterFit(scale) {
						scale.width = 100;
					},
				}
			},
			plugins: {
				legend: {
					display: false
				},
				tooltip: {
					callbacks: {
						label: function(context) {
							var label = context.dataset.label || '';

							if (label) {
								label = ' ' + label + ': ';
							}

							if (context.parsed.y !== null) {
								label += "€ " + context.parsed.y.toLocaleString(self.locale);
							}

							return label;
						}
					}
				}
			}
		}
	});
}

MarginTool.prototype.update = function(values) {
	$.each(this.data, (key, data) => {
		$.each(values[key], (field, value) => {
			data.setData(field, value);
		});

		// console.log(data.getData());
	});

	var data = this.getData();

	this.chart.data.labels[0] = data.abinbev.title + "  € " + data.abinbev.total.toLocaleString(this.locale);
	this.chart.data.labels[1] = data.competition.title + "  € " + data.competition.total.toLocaleString(this.locale);
	this.chart.data.datasets[0].data = [data.abinbev.margin, data.competition.margin];
	this.chart.data.datasets[1].data = [data.abinbev.investmentPerYear, data.competition.investmentPerYear];
	this.chart.data.datasets[2].data = [data.abinbev.bonusManagement, data.competition.bonusManagement];

	this.chart.update();
}

MarginTool.prototype.getDifference = function() {
	return this.data.abinbev.getData().total - this.data.competition.getData().total;
}

MarginTool.prototype.getData = function() {
	return {
		abinbev: this.data.abinbev.getData(),
		competition: this.data.competition.getData()
	}
}

var MarginToolData = function() {
	this.input = {
		volumeEstimationPilsner: null,
		volumeEstimationSpecialties: null,
		bonusManagementPilsner: null,
		bonusManagementSpecialties: null,
		standardGlassSizePilsner: 25,
		sellingPricePilsner: null,
		barrelOrTankContents: 50,
		purchasePriceBarrelOrTank: null,
		investmentPerYear: 0,
		vatRate: .20,
	};

	this.isCompleted = () => {
		return Object.keys(this.input).every((field) => {
			return null !== this.input[field]
		})
	};

	this.bonusManagement = () => {
		return (this.input.volumeEstimationPilsner * this.input.bonusManagementPilsner) + (this.input.volumeEstimationSpecialties * this.input.bonusManagementSpecialties)
	}

	// this.totalInvestment = () => {
	// 	return this.investmentPerYear + this.bonusManagement()
	// }

	// this.totalInvestmentInHl = () => {
	// 	return this.totalInvestment() / (this.volumeEstimationPilsner + this.volumeEstimationSpecialties)
	// }

	this.totalMargin = () => {
		return this.margin() + this.bonusManagement() + this.input.investmentPerYear
	}

	this.margin = () => {
		return Math.floor(this.salesMarginPerHl() * (this.input.volumeEstimationPilsner + this.input.volumeEstimationSpecialties))
	}

	this.standardGlassSizeInLiters = () => {
		return this.input.standardGlassSizePilsner / 100
	}

	this.ptcInEuroPerConsumption = () => {
		return this.input.sellingPricePilsner
	}

	this.ptcInEuroPerHl = () => {
		return this.ptcInEuroPerConsumption() / (this.standardGlassSizeInLiters() / 100)
	}

	// this.netPtcInEuroPerConsumption = () => {
	// 	return this.sellingPricePilsner / (1 + this.input.vatRate)
	// }

	this.netPtcInEuroPerHl = () => {
		return this.ptcInEuroPerHl() / (1 + this.input.vatRate)
	}

	this.netPriceToPOCIncludingTaxesPerConsumption = () => {
		return this.input.purchasePriceBarrelOrTank * (this.standardGlassSizeInLiters() / this.input.barrelOrTankContents * .9)
	}

	this.netPriceToPOCIncludingTaxesPerHl = () => {
		return this.netPriceToPOCIncludingTaxesPerConsumption() / this.standardGlassSizeInLiters() * 100
	}

	// this.salesMarginPerConsumption = () => {
	// 	return this.netPtcInEuroPerConsumption() - this.netPriceToPOCIncludingTaxesPerConsumption()
	// }

	this.salesMarginPerHl = () => {
		return this.netPtcInEuroPerHl() - this.netPriceToPOCIncludingTaxesPerHl()
	}

	// this.bonusPerHlPerConsumptionPilsner = () => {
	// 	return this.bonusManagementPilsner * (this.standardGlassSizeInLiters() / 100)
	// }

	// this.bonusPerHlPerHlPilsner = () => {
	// 	return this.bonusManagementPilsner
	// }

	// this.commercialMarginPerConsumption = () => {
	// 	return this.salesMarginPerConsumption() + this.bonusPerHlPerConsumptionPilsner()
	// }

	// this.commercialMarginPerHl = () => {
	// 	return this.salesMarginPerHl() + this.bonusPerHlPerHlPilsner()
	// }
}

MarginToolData.prototype.setData = function(field, value) {
	if (field === 'title') {
		this.title = value;
		return;
	}

	if (typeof this.input[field] !== 'undefined' && !isNaN(parseFloat(value))) {
		this.input[field] = parseFloat(value);
	}
}

MarginToolData.prototype.getData = function() {
	return {
		title: this.title,
		margin: Math.floor(this.margin()),
		investmentPerYear: Math.floor(this.input.investmentPerYear),
		bonusManagement: Math.floor(this.bonusManagement()),
		total: this.totalMargin(),
		isCompleted: this.isCompleted()
	}
}
